import { Either, left, right } from "fp-ts/lib/Either";
import { injectable } from "inversify";
import ErrorEntity from "../../../domain/entities/ErrorEntity";
import SearchResultEntity from "../../../domain/entities/SearchResultEntity";
import QrRepository from "../../../domain/repositories/QrRepository";
import StablishmentEntity from "../../../domain/entities/StablishmentEntity";
import Testing from "../../../presentation/utils/Testing";
import QrBatchEntity from "../../../domain/entities/QrBatchEntity";
import ScheduleEntity, { ScheduleDay } from "../../../domain/entities/ScheduleEntity";

const fakeQr = new QrBatchEntity({
    id: "qr-123",
    // stablishment: {
    //     id: "stab-001",
    //     name: "Establecimiento Demo",
    //     address: "Calle 123 #45-67",
    //     latitude: 4.6097,
    //     longitude: -74.0817
    // } as StablishmentEntity,
    availables: 20,
    used: 3,

    createdAt: new Date("2024-01-15")
});

@injectable()
export default class QrRepositoryFake implements QrRepository {
    async downloadQrBatch(id: string): Promise<Either<ErrorEntity, void>> {
        await Testing.sleeper(1000);
        return right(undefined);
    }
    async reDownloadQrBatch(_: { zipToken: string, stablishmentId: string }): Promise<Either<ErrorEntity, void>> {
        await Testing.sleeper(1000);
        return right(undefined);
    }
    async createQrsInBatch(quantity: number, stablishmentId: string): Promise<Either<ErrorEntity, void>> {
        await Testing.sleeper(1000);

        // Crear un establecimiento fake para este ID
        const fakeStablishment: StablishmentEntity = {
            id: stablishmentId,
            name: `Establecimiento ${stablishmentId}`,
            address: "Dirección de prueba #123",
            latitude: 4.6097,
            longitude: -74.0817,
            phone: "+1-555-0001",
            email: "email@example.com",
            type: "restaurant",
            managerName: "Manager Name",
            supervisor: {
                id: "supervisor-123",
                name: "John Supervisor",
                phone: "+1-555-0100",
                username: "jsupervisor",
                role: "supervisor" as any,
                document: "12345678",
                documentType: "DNI",
                email: "supervisor@example.com"
            },
            schedules: [
                new ScheduleEntity({ id: "sch-1", day: ScheduleDay.lunes, openTime: "09:00", closeTime: "12:00", }),
                new ScheduleEntity({ id: "sch-2", day: ScheduleDay.lunes, openTime: "14:00", closeTime: "18:00", }),
                new ScheduleEntity({ id: "sch-3", day: ScheduleDay.martes, openTime: "09:00", closeTime: "18:00", })
            ]
        };

        const newQrs: QrBatchEntity[] = [];
        for (let i = 0; i < quantity; i++) {
            const qr = new QrBatchEntity({
                id: `qr-${Date.now()}-${i}`,
                // stablishment: fakeStablishment,
                createdAt: new Date(),
                availables: 20,
                used: 3,
            });
            newQrs.push(qr);
        }
        this.qrs.push(...newQrs);
        return right(undefined);
    }

    private qrs: QrBatchEntity[] = [];

    async createQrsBatch(stablishment: StablishmentEntity, quantity: number): Promise<Either<ErrorEntity, QrBatchEntity[]>> {
        await Testing.sleeper(1000);
        const newQrs: QrBatchEntity[] = [];
        for (let i = 0; i < quantity; i++) {
            const qr = new QrBatchEntity({
                id: `qr-${Date.now()}-${i}`,
                // stablishment: stablishment,
                createdAt: new Date(),
                availables: 20,
                used: 3,
            });
            newQrs.push(qr);
        }
        this.qrs.push(...newQrs);
        return right(newQrs);
    }

    searchQrs = async (_: { stablishmentId?: string | undefined, page: number, itemsPerPage: number }): Promise<Either<ErrorEntity, SearchResultEntity<QrBatchEntity>>> => {
        await Testing.sleeper(1000);
        const limitOfPages = 3;
        if (_.page > limitOfPages) {
            return right({
                total: limitOfPages * _.itemsPerPage,
                data: [],
                itemsPerPage: _.itemsPerPage,
                page: _.page,
                pages: limitOfPages,
            });
        }
        const arrayOfFakes = Array.from({ length: _.page == limitOfPages ? _.itemsPerPage / 2 : _.itemsPerPage }, (__, i) => {
            return fakeQr.copyWith({
                id: `qr-${_.page}-${i}`,
            });
        });
        return right({
            total: (limitOfPages * _.itemsPerPage) - (_.itemsPerPage / 2),
            data: arrayOfFakes,
            itemsPerPage: _.itemsPerPage,
            page: _.page,
            pages: limitOfPages,
        });
    }

    async disableQr(id: string): Promise<Either<ErrorEntity, void>> {
        await Testing.sleeper(1000);
        return right(undefined);
    }
}